export default "__VITE_ASSET__CBK4Od9U__"